import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
  hero: {
    headline: ["UNLOCK YOUR", "VEHICLE'S", "POTENTIAL"],
    subtext: "Professional ECU remapping, Stage 1 tuning and vehicle diagnostics from Rochdale — serving Greater Manchester and the surrounding areas.",
    image: "",
  },
  contact: {
    email: "themaplab1@outlook.com",
    phone: "",
    whatsapp: "",
    instagram: "themaplab",
    location: "Rochdale, Greater Manchester",
    service_area: "Rochdale, Greater Manchester & surrounding areas",
  },
  services: [],
  why: [],
  faqs: [],
  about: { title: "", paragraphs: [] },
  pricing_note: "",
  marquee: "",
};

export function useContent() {
  const query = useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await axios.get(`${API}/content`)).data,
    staleTime: 60_000,
    retry: 1,
  });
  return { content: query.data || FALLBACK, isLoading: query.isLoading };
}
